export var KULT_0501_METHODOLOGY_DIAGNOSTIC_CODES = [
    "EXCLUDED_YEARBOOK",
    "PROVISIONAL_SUBJECT_MAPPING",
];
export var KULT_0501_INCOMPLETE_VALUE_DIAGNOSTIC_CODES = [
    "UNKNOWN_START_YEAR",
];
